import { ILocaleConfig } from "@/config/locale.config";
import { SupportedLocale, LocaleToLabelMap } from "@/enums/locale.enum";

// Georgia-specific locale configuration
const georgiaLocaleConfig: ILocaleConfig = {
  supportedLocales: [SupportedLocale.EN, SupportedLocale.RU],
  defaultLocale: SupportedLocale.EN,
  languageTabs: [
    {
      key: SupportedLocale.EN,
      label: LocaleToLabelMap.get(SupportedLocale.EN)!,
    },
    {
      key: SupportedLocale.RU,
      label: LocaleToLabelMap.get(SupportedLocale.RU)!,
    },
  ],
};

export default georgiaLocaleConfig;
